import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, } from '@chakra-ui/react';
import Text from '../../content/text';
import Button from '../../inputs/button';
import { Kind } from '../../inputs/button/constants/kind';
import FONTS from '../../../constants/fonts';
import COLORS from '../../../constants/colors';
const ConfirmationDialog = ({ isOpen, onClose, onConfirm, title, message, confirmButtonText, cancelButtonText, }) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };
    return (<Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="md" p={2}>
        <ModalHeader paddingBottom={2}>
          <Text font={FONTS.T1.T16Px.Bold700.value} color={COLORS.Text.T500.value}>
            {title}
          </Text>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody paddingY={2}>
          <Text font={FONTS.T1.T14Px.Regular400.value} color={COLORS.Text.T400.value} numberOfLines={5}>
            {message}
          </Text>
        </ModalBody>

        <ModalFooter gap={3}>
          <Button kind={Kind.OUTLINE} onPress={onClose}>
            {cancelButtonText}
          </Button>
          <Button kind={Kind.SECONDARY} onPress={handleConfirm}>
            {confirmButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>);
};
export default ConfirmationDialog;
